const ShowHeader = ( {show} ) => {
  return ( 
    <div>
      <h1>{show.name}</h1>
      <p>{show.network} &middot; {show.year}</p>
    </div>
  );
}

export default ShowHeader;